import React, { useEffect, useRef } from 'react'

interface ClosingMessageProps {
  messageHeader: string
  messageTxt: string
}

export default function TimeOut({
  messageHeader,
  messageTxt,
}: ClosingMessageProps) {

  const timeOutRef = useRef<HTMLDivElement>(null);

  useEffect(()=>{
    timeOutRef.current?.focus();
  },[])
  
  return (
    <div tabIndex={0} ref={timeOutRef}>
      <section className=" flex flex-col theme-survey-complete fade-in m-h-full">
      <h1 className="text-5xl md:text-7xl py-10 font-extrabold text-center"><i className="theme-error-icon fa-solid fa-timer"></i> <span className='theme-error-header'>{messageHeader}</span></h1>
      <div className="text-2xl theme-error-text text-center">{messageTxt}</div>
      </section>
    </div>
  )
}

